import TinyMCE from "components/TinyMCE";
import { useSelector, useDispatch } from "react-redux";
import { getRxAppData, setRxAppData } from '../redux/appCenterSlice';

export default function Documentation() {
  const dispatch = useDispatch();
  const app = useSelector(getRxAppData);

  const saveChange = (text: string) => {
    app.documentation = text;
    dispatch(setRxAppData(app));
  }

  return (
    <TinyMCE editorText={app.documentation} header={'Documentation'} onSave={saveChange}></TinyMCE>
  ) 
}

